var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "ai ai-Hashtag text-5xl h-12 w-12 stroke-[#7b29f4]",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3L6 21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3l-4 18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16h17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.f050a631747cd946425dddcef451fb9f.svg";
export { ForwardRef as ReactComponent };